import { useQuery } from '@rocicorp/zero/react'
import { formatCents, formatTime } from '../../lib/format.ts'
import { queries } from '../../zero/queries.ts'
import { PagedSection, usePagedLimit } from './PagedSection.tsx'

/**
 * Every drink on the tab, paid or not. The remove control lives on the
 * outstanding list instead — this is the complete record.
 */
export function DrinkHistory({ userId }: { userId: string }) {
  const { limit, showMore } = usePagedLimit()
  const [drinks, result] = useQuery(queries.drinkHistoryForUser({ userId, limit }))

  return (
    <PagedSection
      title="Drink history"
      shown={drinks.length}
      limit={limit}
      showMore={showMore}
      complete={result.type === 'complete'}
      emptyText="No drinks recorded."
    >
      {drinks.map((drink) => {
        const paid = drink.paidAt != null
        return (
          <div className="line" key={drink.id}>
            <div className="line-main">
              <div className="line-title">
                {drink.drink?.description ?? 'Drink'}
                <span className={`pill-tag ${paid ? '' : 'pill-tag--owing'}`}>
                  {paid ? 'Paid' : 'Outstanding'}
                </span>
                {drink.guest ? <span className="muted"> · for {drink.guest.name}</span> : null}
              </div>
              <div className="line-sub">{formatTime(drink.purchasedAt)}</div>
            </div>
            <span className="line-amount">{formatCents(drink.drink?.priceCents ?? 0)}</span>
          </div>
        )
      })}
    </PagedSection>
  )
}
